import { Liquidate } from './Liquidate'

export default Liquidate
